var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaylink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4289_4616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7141 11.1424V13.1424C13.7141 13.4455 13.5937 13.7363 13.3794 13.9506C13.1651 14.1648 12.8744 14.2853 12.5713 14.2853H1.71415C1.41104 14.2853 1.12035 14.1648 0.906024 13.9506C0.691697 13.7363 0.571289 13.4455 0.571289 13.1424V5.14244C0.571289 3.2489 2.10632 1.71387 3.99986 1.71387M11.4284 4.57101V1.71387H7.99984",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 7.71387H10.8571C10.5415 7.71387 10.2856 7.96971 10.2856 8.2853V10.571C10.2856 10.8866 10.5415 11.1424 10.8571 11.1424H14.8571C15.1726 11.1424 15.4285 10.8866 15.4285 10.571V8.2853C15.4285 7.96971 15.1726 7.71387 14.8571 7.71387Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.714 7.71415V5.71415C13.714 5.41104 13.5935 5.12035 13.3792 4.90602C13.1649 4.6917 12.8742 4.57129 12.5711 4.57129H8.28539H7.33301M3.33301 4.57129H4.66634",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.33301V9.33301",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71436 7.04785L6.00007 9.33357L8.28578 7.04785",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4289_4616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaylink);
export default __webpack_public_path__ + "static/media/paylink.101b5610d63299c48ed2a3dd0b18ff46.svg";
export { ForwardRef as ReactComponent };